import { DataLayer } from '@pulse/browser-shared';
import { PluginHost } from '@pulse/browser-tracker-shared';
import { AnalyticsPlugin, TrackerConfigurations } from '@pulse/common';
import {
    ClickEventPlugin,
    ConsentEventPlugin,
    ContextMenuPlugin,
    DataLayerPlugin,
    DeviceAttributesPlugin,
    FacebookPixelAttributePlugin,
    InfectedPlugin,
    NavigationEventPlugin,
    PopupEventPlugin,
    RUMPlugin,
    SessionStartEventPlugin,
    StatePlugin,
    TabLinkingPlugin,
    VisibilityChangePlugin,
} from '../plugins';
import { DebugEventPlugin } from '../plugins/live-event-debug.plugin';

export class PluginsFactory {
    constructor(
        private sessionStartPlugin: SessionStartEventPlugin,
        private navigationEventPlugin: NavigationEventPlugin,
        private infectedPlugin: InfectedPlugin,
        private visibilityChangePlugin: VisibilityChangePlugin,
        private clickEventPlugin: ClickEventPlugin,
        private tabLinkingPlugin: TabLinkingPlugin,
        private statePlugin: StatePlugin,
        private deviceAttributesPlugin: DeviceAttributesPlugin,
        private consentEventPlugin: ConsentEventPlugin,
        private pluginHost: PluginHost,
        private config: TrackerConfigurations,
        private facebookPixelAttributePlugin: FacebookPixelAttributePlugin,
        private popupEventPlugin: PopupEventPlugin,
        private contextMenuPlugin: ContextMenuPlugin,
        private internalDataLayer: DataLayer | undefined,
        private debugEventPlugin: DebugEventPlugin,
        private rumPlugin: RUMPlugin,
        private dataLayer?: DataLayer | undefined,
    ) {}

    registerPlugins() {
        const plugins: AnalyticsPlugin[] = [
            this.visibilityChangePlugin,
            this.debugEventPlugin,
            this.clickEventPlugin,
            this.tabLinkingPlugin,
            this.statePlugin,
            this.sessionStartPlugin,
            this.navigationEventPlugin,
            this.infectedPlugin,
            this.deviceAttributesPlugin,
            this.consentEventPlugin,
            this.facebookPixelAttributePlugin,
            this.popupEventPlugin,
            this.contextMenuPlugin,
            this.rumPlugin,
            ...(this.config.plugins || []),
        ];

        if (this.dataLayer) {
            plugins.push(new DataLayerPlugin(this.dataLayer, 'paa.', this.visibilityChangePlugin));
        }

        if (this.internalDataLayer && Array.isArray(this.internalDataLayer)) {
            plugins.push(
                new DataLayerPlugin(this.internalDataLayer, '', this.visibilityChangePlugin),
            );
        }

        //
        // Register
        ////////////////////////////
        plugins.forEach((plugin) => this.pluginHost.register(plugin));
    }
}
